var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPdf = function SvgPdf(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DC2626",
    d: "M11 .001v2.24c0 .805 0 1.47.044 2.01.046.563.145 1.08.392 1.565a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C15.29 8 15.954 8 16.758 8h2.24c.002.168.002.346.002.537V10H1V7.357c0-1.084 0-1.958.058-2.666.06-.728.185-1.369.487-1.96A5 5 0 0 1 3.73.544C4.322.243 4.963.117 5.691.058 6.4 0 7.273 0 8.357 0h2.106L11 .001Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DC2626",
    d: "M13 .283V2.2c0 .857 0 1.439.038 1.889.035.438.1.663.18.819a2 2 0 0 0 .874.874c.156.08.38.145.819.18C15.361 6 15.943 6 16.8 6h1.918a4.995 4.995 0 0 0-.455-.956c-.31-.506-.735-.93-1.35-1.545L15.5 2.085c-.614-.613-1.039-1.038-1.544-1.348A4.996 4.996 0 0 0 13 .283Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DC2626",
    fillRule: "evenodd",
    d: "M1 12a1 1 0 0 0-1 1v7a1 1 0 1 0 2 0v-1h.5a3.5 3.5 0 1 0 0-7H1Zm1.5 5H2v-3h.5a1.5 1.5 0 0 1 0 3ZM8 12a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h.5a4.5 4.5 0 1 0 0-9H8Zm3 4.5a2.5 2.5 0 0 1-2 2.45v-4.9a2.5 2.5 0 0 1 2 2.45Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#DC2626",
    d: "M15 12a1 1 0 0 0-1 1v7a1 1 0 1 0 2 0v-2h3a1 1 0 1 0 0-2h-3v-2h3a1 1 0 1 0 0-2h-4Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPdf);
export default ForwardRef;